<template>
  <div class="eol-bread-box" @breadConfig="breadConfig">
    <div class="bread-title" v-for="item,index in breadConfig" :key="index" @click="goRouters(item)">{{item.name}}</div>
  </div>
</template>

<script>
export default {
  props: {
    breadConfig: {
      type: Array,
    }
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
    }
  },
  methods: {
    goRouters (item) {
      if (item && item.path) {
        let params = { path: item.path, query: this.$route.query, params: this.$route.params };
        this.$router.push({ path: `/${this.school_code}/school${params.path}`, params: params.params, query: params.query },);
      }
    }
  }
}
</script>

<style  lang="less">
.eol-bread-box {
    display: flex;
    align-items: center;
    line-height: 1;
    padding: 18px 0;
}

.eol-bread-box .bread-title {
    display: inline-block;
    color: #474747;
    // cursor: pointer;
}
// .eol-bread-box .bread-title:hover {
//     color: #125cfd;
// }
.eol-bread-box .bread-title::after {
    content: '-';
    margin: 0 5px;
    display: inline-block;
}
.eol-bread-box .bread-title:last-child {
    cursor: text;
}
.eol-bread-box .bread-title:last-child::after {
    content: '';
    display: none;
}
</style>